var map = {
	"./assignments/bronze.png": "3a8e",
	"./assignments/gold.png": "a170",
	"./assignments/silver.png": "009f",
	"./battlepack_gold.png": "c230",
	"./bf1_logo.png": "f905",
	"./bf1_rank.png": "0631",
	"./bf4_logo.png": "b18e",
	"./country-flags/america-flag.png": "b1d4",
	"./country-flags/germany-flag.png": "d902",
	"./country-flags/netherlands-flag.png": "c6b7",
	"./country-flags/russia-flag.png": "6c5d",
	"./country-flags/uk-flag.png": "ae40",
	"./level.png": "624d",
	"./soldier.png": "75b6",
	"./soldier_dogtags.png": "09ca",
	"./weapons/acw-black.png": "1e42",
	"./weapons/acw-white.png": "47c3",
	"./weapons/engineer-black.png": "dd70",
	"./weapons/engineer-white.png": "82ea",
	"./weapons/m9-black.png": "f3d0",
	"./weapons/m9-white.png": "ec9d",
	"./weapons/tank-black.png": "cf2e",
	"./weapons/tank-white.png": "9705"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";